import React from "react";
import {WidgetProps} from "../widget";
import {ArticleSearch} from "../../../../../articles/common/article-search/article-search";

export const UIInputWidgetArticle: React.FC<WidgetProps> = ({value, onChange}) => {

    return (
        <ArticleSearch onChange={onChange} value={value as any} />
    )
}